<template>
  <div class="empty-state">
    <img v-if="image" class="icon" :src="image" alt />
    <div class="info-wrap">
      <h3 class="title heading-m">
        <slot name="title">
          {{ title || 'Заголовок' }}
        </slot>
      </h3>
      <div class="description">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  image: String,
  title: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" src="./empty-state.scss" scoped />
